import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { Typography, Modal, useMediaQuery, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import theme from "../theme/theme";

const Modules = ({ loading, introData }) => {

    const mobile = useMediaQuery(theme => theme.breakpoints.down('md'));

    const [modulesData, setModulesData] = useState([]);

    const [selectedModule, setSelectedModule] = useState(null);

    const [open, setOpen] = useState(false);

    const handleOpen = (module) => {
        setSelectedModule(module);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const style = {
        position: 'absolute',
        top: '150px',
        left: '50%',
        transform: 'translate(-50%, 0%)',
        bgcolor: 'background.paper',
        padding: '50px 40px',
        width: '90%',
        height: 'calc(95vh - 150px)',
        overflow: 'scroll',
        outline: 'none!important',
        maxWidth: `${theme.width.maxwidth}`,
    };


    useEffect(() => {
        axios({
            method: 'get',
            url: `${WP_API_Settings.endpoint}wp/v2/theme_riskwisemodule?_embed=true&acf_format=standard`,
        })
            .then(response => {

                console.log('Modules', response.data);

                const modules = response.data.filter(module => module.title.rendered !== 'Fire Safety Management');

                setModulesData(modules); // Store the data in state
                //Get Featured Image URL for each Module
                response.data.map((module) => {
                    axios({
                        method: 'get',
                        url: `${WP_API_Settings.endpoint}wp/v2/media/${module.featured_media}`,
                    })
                        .then(response => {
                            setModulesData(prevState => {
                                return prevState.map((moduleData) => {
                                    if (moduleData.id === module.id) {
                                        return {
                                            ...moduleData,
                                            featured_image_url: response.data.source_url,
                                        };
                                    }
                                    return moduleData;
                                });
                            });
                        })
                        .catch(error => {
                            console.error('Error fetching modules:', error);
                        });
                });
            })
            .catch(error => {
                console.error('Error fetching modules:', error);
            });
    }, []);

    const replaceAmpersand = (text) => {
        return text.replace(/&amp;/g, '&');
    };

    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    padding: '50px 0',
                    backgroundColor: '#F0F0F0',
                }}
            >
                <Container maxWidth="xl">
                    {loading ?
                        mobile ?
                            <>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height="2.1rem"
                                    sx={{
                                        maxWidth: '600px',
                                        margin: '0 auto 30px auto',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    height="22px"
                                    sx={{
                                        margin: 'auto',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="100%"
                                    height="300px"
                                    sx={{
                                        margin: '0 auto 20px auto',
                                    }}
                                />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'space-between',
                                        alignItems: 'stretch',
                                    }}
                                >
                                    {Array.from({ length: 8 }).map((_, index) => (
                                        <Skeleton
                                            variant="rectangular"
                                            width="calc(100% - 16px)"
                                            height="174px"
                                            sx={{
                                                margin: '0 0 20px 0',
                                            }}
                                        />
                                    ))}
                                </Box>
                            </>
                            :
                            <>
                                <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height="2.1rem"
                                    sx={{
                                        maxWidth: '600px',
                                        margin: '0 auto 30px auto',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="90%"
                                    height="22px"
                                    sx={{
                                        margin: 'auto',
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    width="80%"
                                    height="22px"
                                    sx={{
                                        margin: '0 auto 60px auto',
                                    }}
                                />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'space-between',
                                        alignItems: 'stretch',
                                    }}
                                >
                                    {Array.from({ length: 8 }).map((_, index) => (
                                        <Skeleton
                                            variant="rectangular"
                                            width="calc(25% - 16px)"
                                            height="394px"
                                            sx={{
                                                margin: '0 0 20px 0',
                                            }}
                                        />
                                    ))}
                                </Box>
                            </>
                        :
                        <>
                            {introData && introData?.heading && (
                                <Typography
                                    sx={{
                                        color: '#265DA5',
                                        textAlign: 'center',
                                        fontSize: '1.5rem',
                                        fontWeight: '600',
                                        marginBottom: '30px',
                                    }}
                                    dangerouslySetInnerHTML={{ __html: introData.heading }}
                                />
                            )}
                            {introData && introData?.description && (
                                <Typography
                                    sx={{
                                        textAlign: 'center',
                                        marginBottom: '60px',
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: introData.description,
                                    }}
                                />
                            )}

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'center',
                                    alignItems: 'stretch',
                                    gap: '20px',
                                }}
                            >
                                {Array.isArray(modulesData) &&
                                    modulesData.map((module) => (
                                        module.featured_image_url ? (
                                            <Box
                                                onClick={() => handleOpen(module)}
                                                key={module.id}
                                                sx={{
                                                    width: 'calc(25% - 16px)',
                                                    width: mobile ? '100%' : 'calc(25% - 16px)',
                                                    backgroundColor: '#FFFFFF',
                                                    marginBottom: '0px',
                                                    padding: '20px 25px 40px',
                                                    cursor: 'pointer',
                                                    transition: 'box-shadow 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                                                    },
                                                    display: mobile ? 'flex' : 'block',
                                                    flexDirection: 'row-reverse',
                                                }}
                                            >
                                                {/* {!mobile && ( */}
                                                <img
                                                    src={module.featured_image_url}
                                                    alt={module.title.rendered}
                                                    style={{
                                                        display: 'block',
                                                        width: mobile ? '30%' : '100%',
                                                        marginBottom: mobile ? '0' : '30px',
                                                        cursor: 'pointer',
                                                        objectFit: 'contain',
                                                        minHeight: mobile ? 'unset' : '225px',
                                                        maxHeight: mobile ? 'unset' : '225px'
                                                    }}
                                                />
                                                {/* )} */}
                                                <Box
                                                    sx={{
                                                        width: mobile ? '70%' : '100%',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#E9531C',
                                                            textAlign: 'left',
                                                            fontSize: '1.2rem',
                                                            fontWeight: '600',
                                                            lineHeight: '1.167',
                                                            marginBottom: '1em',
                                                            cursor: 'pointer',
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: replaceAmpersand(module.title.rendered) }}
                                                    />
                                                    <Box
                                                        sx={{
                                                            textAlign: 'left',
                                                            cursor: 'pointer',
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: module.excerpt.rendered,
                                                        }}
                                                    />
                                                </Box>
                                            </Box>
                                        ) : (
                                            mobile ? (
                                                <Skeleton
                                                    variant="rectangular"
                                                    width="100%"
                                                    height="174px"
                                                    sx={{
                                                        margin: '0 0 20px 0',
                                                    }}
                                                />
                                            ) : (
                                                <Skeleton
                                                    variant="rectangular"
                                                    width="calc(25% - 16px)"
                                                    height="394px"
                                                    sx={{
                                                        margin: '0 0 20px 0',
                                                    }}
                                                />
                                            )
                                        )
                                    ))
                                        .reverse()
                                }
                            </Box>
                        </>
                    }
                </Container>
            </Box>
            {Array.isArray(modulesData) && modulesData.map((module) => (
                <Modal
                    open={open && selectedModule === module}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    key={`modal-${module.id}`}
                >
                    <Box
                        sx={style}
                    >
                        <FontAwesomeIcon
                            icon={faTimes}
                            style={{
                                position: 'absolute',
                                top: '20px',
                                right: '30px',
                                cursor: 'pointer',
                                fontSize: '2rem',
                                color: '#0D60A8',
                            }}
                            onClick={handleClose}
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: mobile ? 0 : '60px',
                                flexDirection: mobile ? 'column-reverse' : 'row',
                            }}
                        >
                            <Box
                                sx={{
                                    width: mobile ? '100%' : '63%',
                                }}
                            >
                                <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                    sx={{
                                        fontSize: '1.8rem',
                                        fontWeight: '800',
                                        color: '#0D60A8',
                                    }}
                                    dangerouslySetInnerHTML={{ __html: replaceAmpersand(module.title.rendered) }}
                                />
                                <Typography
                                    id="modal-modal-description"
                                    sx={{ mt: 2, marginBottom: '20px' }}
                                    dangerouslySetInnerHTML={{
                                        __html: module.content.rendered,
                                    }}
                                />
                                {module.acf.module_bullets.map((bullet, index) => (
                                    <Box
                                        sx={{
                                            marginBottom: '20px',
                                            display: 'flex',
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faCheckCircle}
                                            style={{
                                                color: module.acf.module_colour,
                                                marginRight: '10px',
                                                marginTop: '4px',
                                            }}
                                        />
                                        <Typography
                                            key={index}
                                        >
                                            {bullet.bullet_text}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                            <img
                                src={module.featured_image_url}
                                alt={module.title.rendered}
                                style={{
                                    width: mobile ? '100%' : '32%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    marginBottom: mobile ? '16px' : 0,
                                }}
                            />
                        </Box>
                    </Box>
                </Modal>

            ))}
        </>
    );

}

export default Modules;